<div class="item_peguntas">
    <div class="ilcont_itempreguntas">
        <div class="icono_punteo"><img src="assets/images/vectors82551948.svg" width="8px" height="8px"
                class="vector_vector"></div>
        <div class="contenido_item_pregunta"><a class="a_vinculo" (click)="ejecutarFuncion()">{{pregunta}}</a></div>
    </div>
</div>